
import CustomerAndPackageView from "./Steps/CustomerAndPackage";
import { ORDER_STEP } from "#/pages/Order/Order/Order.interface";
import { OrderCreate } from "#/pages";
import { useApi } from "@/api";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useOrderTemplate } from "@/hooks";

const OrderCreateView = () => {
  const navigate = useNavigate();
  const { session } = useApi();

  const isAdmin = useMemo(() => session.user?.admin || false, [session.user]);

  const {
    selectedOrderTemplate,
  } = useOrderTemplate();

  const handleSaveOrder = () => true;

  const handleSelectOrderTemplate =async (branchId: number, orderTypeId: number) => {
    navigate(`/order-new/brid=${branchId}/pkgid=${orderTypeId}`);
  };

  return (
    <>
      <OrderCreate
        activeStep={ORDER_STEP.CUSTOMER_AND_PACKAGE}
        isAdmin={isAdmin}
        selectedOrder={selectedOrderTemplate}
        onCreateOrder={handleSaveOrder}
      >
        <CustomerAndPackageView
          isAdmin={isAdmin}
          selectOrderTemplate={handleSelectOrderTemplate}
      />
      </OrderCreate>
    </>
  );
}

export default OrderCreateView;
